import React, { useState } from 'react';
import * as S from './DeleteLog.styled';
import EscapeButton from 'pages/components/EscapeButton/EscapeButton';
import { Log, useLogs } from '../hooks';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { deleteLog, selectLogsChecked, setLogsChecked } from '../redux';
import Loader from 'pages/components/Loader/Loader';
import { toast } from 'utils/toast';
import { selectCurrency } from 'pages/redux';
import { useSocketEmit } from 'pages/Navigation/hooks';
import DeleteOutline from '@mui/icons-material/DeleteOutline';

const DeleteLog = ({
  onExit,
  log,
} : {
  onExit: Function,
  log: Log,
  /** @deprecated unused — table row index was shown as #id before UUID logs */
  id?: string | number
}) => {
  const displayLog = { ...log };
  const logsChecked = useAppSelector(selectLogsChecked);
  const currency = useAppSelector(selectCurrency);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { deleteLocalLog, updateLocalLog } = useLogs();
  const socketEmit = useSocketEmit();

  const dispatch = useAppDispatch();
  const amountLabel = `${currency}${Number(displayLog.value).toLocaleString()}`;
  const typeLabel = displayLog.type || 'Audit';

  const onDeleteLog = async () => {
    const logToDelete = {
      dId: displayLog.id.toString(),
      type: displayLog.type,
      value: displayLog.value
    };
    setIsLoading(true);

    const res = await dispatch(deleteLog(logToDelete));

    if (res.status === 'success') {
      deleteLocalLog(displayLog.id);
      // Prefer the API-returned "Audit deleted" row so it still appears if the
      // socket get_added_log event is lost during listener rebind.
      if (res.data && typeof res.data === 'object' && res.data.id != null) {
        updateLocalLog(res.data as Log);
      }
      socketEmit('delete_log', { logId: displayLog.id });
      const newChecked = [...logsChecked.filter((c: string) => c !== 'Audit deleted'), 'Audit deleted'];
      dispatch(setLogsChecked(newChecked));
      setIsLoading(false);
      toast('Successfully deleted audit', { type: 'success' });
      onExit(true);
      return;
    }

    setIsLoading(false);
    toast(res.data, { type: 'error' });
  };

  return (
    <>
      {
        isLoading ? <Loader isSticky /> : (
          <S.Container>
            <EscapeButton onClick={() => onExit()} />
            <S.Header>
              <S.DangerIcon aria-hidden>
                <DeleteOutline fontSize="inherit" />
              </S.DangerIcon>
              <S.MainLabel>Delete audit entry</S.MainLabel>
              <S.SubLabel>
                This permanently removes the entry from your audit log.
              </S.SubLabel>
            </S.Header>
            <S.EntryCard>
              <S.EntryCardLabel>Amount</S.EntryCardLabel>
              <S.EntryAmount>{amountLabel}</S.EntryAmount>
              <S.EntryMeta>
                {typeLabel}
                {' · '}
                <S.EntryId>audit</S.EntryId>
              </S.EntryMeta>
            </S.EntryCard>
            <S.Actions>
              <S.SecondaryBtn type="button" onClick={() => onExit()}>
                Cancel
              </S.SecondaryBtn>
              <S.DangerBtn type="button" onClick={() => onDeleteLog()}>
                Delete entry
              </S.DangerBtn>
            </S.Actions>
          </S.Container>
        )
      }
    </>
  );
};

export default DeleteLog;
